<template>
  <div class="contents">
    <top></top>
    <div class="invite-list">
      <div class="search">
        <div class="search_l">
          <el-select
            @change="getInviteList(1)"
            v-model="queryParams.status"
            prefix-icon="el-icon-search"
            style="margin-right: 10px"
            size="small"
            clearable
            placeholder="状态"
            placeholder-class="placeholder_text"
          >
            <el-option label="已完成" :value="1"> </el-option>
            <el-option label="待加入" :value="0"> </el-option>
          </el-select>
          <el-date-picker
            @change="handleDate"
            v-model="date"
            type="datetimerange"
            format="yyyy-MM-dd HH:mm:ss"
            value-format="yyyy-MM-dd HH:mm:ss"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            size="small"
          >
          </el-date-picker>
        </div>
        <div class="search_r">
          <el-input
            @change="getInviteList(1)"
            placeholder="请输入邮箱"
            prefix-icon="el-icon-search"
            size="small"
            clearable
            v-model="queryParams.inviterEmail"
          >
          </el-input>
        </div>
      </div>
      <div class="table_box">
        <el-table :data="inviteList" v-loading="loading" height="100%">
          <el-table-column label="邀请邮箱地址" prop="inviterEmail"></el-table-column>
          <el-table-column label="状态" prop="status">
            <template #default="scope">
              <el-tag v-if="scope.row.status == 1" type="success" size="small">已完成</el-tag>
              <el-tag v-else type="warning" size="small">待加入</el-tag>
            </template>
          </el-table-column>
          <el-table-column label="创建时间" prop="createTime"></el-table-column>
        </el-table>
      </div>
      <div class="table-pagination">
        <el-pagination
          background
          class="penye"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          layout="total, prev, pager, next"
          :total="total"
        >
        </el-pagination>
      </div>
    </div>
    <sub-dialog :visible="subdialogvis"></sub-dialog>
  </div>
</template>
<script>
import top from "./components/top.vue";
export default {
  data() {
    return {
      loading: false,
      inviteList: [],
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        startTime: null,
        endTime: null,
        status: null,
        inviterEmail: null,
      },
      date: [],
      total: 0,
    };
  },
  mounted() {
    this.getInviteList();
  },
  computed: {
    roles() {
      return this.$store.state.userStore.roles;
    },
    subdialogvis() {
      return this.$store.state.userStore.packageInfo.isMember;
    },
  },
  components: {
    top,
  },
  methods: {
    handleDate(e) {
      if (e) {
        this.queryParams.startTime = e[0];
        this.queryParams.endTime = e[1];
        this.getInviteList(1);
      } else {
        this.queryParams.startTime = null;
        this.queryParams.endTime = null;
        this.getInviteList(1);
      }
    },
    handleSizeChange(val) {
      this.queryParams.pageSize = val;
      this.getInviteList();
    },
    handleCurrentChange(val) {
      this.queryParams.pageNum = val;
      this.getInviteList();
    },
    getInviteList(val) {
      this.loading = true;
      if (val == 1) {
        this.queryParams.pageNum = 1;
      }
      this.$http({
        url: "/customer/inviteRecord/list",
        method: "POST",
        data: this.queryParams,
      })
        .then((res) => {
          this.inviteList = res.rows;
          this.total = res.total;
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.contents {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.invite-list {
  flex: 1;
  padding: 20px;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.search {
  display: flex;
  justify-content: space-between;
  padding: 10px 0;
  flex-shrink: 0;
}

.search_l {
  display: flex;
  justify-content: flex-start;
  width: 60%;
}

.search_r {
  width: 30%;
}

.table_box {
  width: 99%;
  height: 100%;
}

.table-button {
  margin-right: 10px;
  font-size: 20px;
}

.table-pagination {
  flex-shrink: 0;
  text-align: right;
  padding-top: 20px;
}

.topInvite {
  text-align: right;
  cursor: pointer;
}
</style>
